import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';

import AddCustomerDetail from './AddCustomerDetail';
import SurveyType from './SurveyType';
import AddSurveyDetails from './AddSurveyDetails';
import generalfnction from '../../../services/generalService';
import { toast } from 'react-toastify';
import Q from 'q';
import { SAVE_CUSTOMER_DETAILS } from '../../../services/inventory-funding/opsee.gql';
import { executeGraphQLMutation } from '../../../services/inventory-funding/executeGraphQLQuery';
import { useApolloClient } from '@apollo/client';
import { FCI_ADMIN_ACCESS_ROLE, FCI_IF_ACCESS_ROLE } from '../../../config/IFConstant';

const LeadDetailTabs = (props) => {
  console.log(props);
  let loginData = JSON.parse(localStorage.getItem('user_information'));
  const client = useApolloClient();
  const [activeStep, setActiveStep] = useState(1);
  const [customerDetails, setCustomerDetails] = useState({
    lead_type: (loginData?.role_id?.includes(FCI_IF_ACCESS_ROLE) || loginData?.role_id?.includes(FCI_ADMIN_ACCESS_ROLE)) ? 'if' :'cf',
    pb_full_name: '',
    pb_mobile: '',
    is_co_borrower_enable: false,
    cb_full_name: '',
    cb_mobile: '',
  });

  const [selectedSurveys, setSelectedSurveys] = useState([]);

  const [surveyDetails, setSurveyDetails] = useState([]);
  const [uploadedFileNames, setUploadedFileNames] = useState({});
  const [loading, setLoading] = useState(false);

  const uploadSurveyDoc = async (event, surveyTypeId, s_id) => {
    setLoading(true);
  
    let files = Array.from(event.target.files);
    let awsRes = [];
  
    if (files.length) {
      const formData = new FormData();
      formData.append("upload_type", "dif_docs");
      formData.append("lead_id", surveyTypeId);
  
      files.forEach((file) => {
        formData.append("images", file);
      });
  
      awsRes.push(
        generalfnction.uploadFilesToS3(formData, {
          "Content-Type": "multipart/form-data",
        })
      );
    } else {
      setLoading(false);
      return;
    }
  
    try {
      const uploadOutput = await Q.allSettled(awsRes);
  
      let uploadedUrls = [];
  
      uploadOutput.forEach((res) => {
        if (
          res.state === "fulfilled" &&
          res.value?.data?.data?.length
        ) {
          res.value.data.data.forEach((row) => {
            uploadedUrls.push(row.file_url);
          });
        }
      });
  
      // UPDATE survey_details STATE
      setSurveyDetails((prev) =>
        prev.map((survey) =>
          (survey.survey_type_id === surveyTypeId && survey.id === s_id)
            ? {
                ...survey,
                survey_details: {
                  ...survey.survey_details,
                  doc_urls: [
                    ...(survey.survey_details?.doc_urls || []),
                    ...uploadedUrls,
                  ],
                },
              }
            : survey
        )
      );

      const key = `${surveyTypeId}_${s_id}`;
      setUploadedFileNames(prev => ({
        ...prev,
        [key]: [
          ...(prev[key] || []),
          ...files.map(f => f.name)
        ]
      }));
  
    } catch (error) {
      toast.error("Upload failed");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const SaveCustomerDetails = (task_id,e) => {
     setLoading(true);
     const variables = {
        createCustomerInput: {
            lead_type: customerDetails.lead_type,
            pb_full_name: customerDetails.pb_full_name,
            pb_mobile: customerDetails.pb_mobile,
            is_co_borrower_enable: customerDetails.is_co_borrower_enable ? '1' : '0',
            cb_full_name: customerDetails.is_co_borrower_enable
              ? customerDetails.cb_full_name
              : null,
            cb_mobile: customerDetails.is_co_borrower_enable
              ? customerDetails.cb_mobile
              : null,
            created_by: loginData?.id || 0,
            survey_types: surveyDetails?.map(({ id, count, ...rest }) => rest),
          }
     }
     if(!customerDetails) toast.error("Please enter valid customer details");
     if(!surveyDetails?.length) toast.error("Please Enter Valid Survey Details");
     executeGraphQLMutation(SAVE_CUSTOMER_DETAILS(),variables,client).then(res=> {
        toast.success(res?.data?.add_customer_details?.message);
        props.hideModalSurveyRequest();
        props.getTaskViewList();
        setCustomerDetails({
            lead_type: (loginData?.role_id?.includes(FCI_IF_ACCESS_ROLE) || loginData?.role_id?.includes(FCI_ADMIN_ACCESS_ROLE)) ? 'if' :'cf',
            pb_full_name: '',
            pb_mobile: '',
            is_co_borrower_enable: false,
            cb_full_name: '',
            cb_mobile: '',
        });
        setSelectedSurveys([]);
        setSurveyDetails([]);
        setUploadedFileNames({});
        setActiveStep(1);
        setLoading(false)
     }).catch(err=> {
        setLoading(false);
        toast.error("Something went wrong");
     })
    }

  let customerDetailCond = customerDetails.is_co_borrower_enable === false ? (customerDetails?.pb_full_name && customerDetails?.pb_mobile) : (customerDetails?.pb_full_name && customerDetails?.pb_mobile && customerDetails?.cb_full_name && customerDetails?.cb_mobile);

  const isSurveyValid = (survey) => {
    const details = survey.survey_details;
  
    return (
      details &&
      details.name?.trim() &&
      details.address?.trim() &&
      details.province_id !== null &&
      details.city_id !== null &&
      details.other_instruction?.trim()
    //   Array.isArray(details.doc_urls) &&
    //   details.doc_urls.length > 0
    );
  };
  const isValidSurveyDetails = surveyDetails.length > 0 && surveyDetails.every(isSurveyValid);
  console.log("****************",customerDetails,surveyDetails,selectedSurveys)
  return (
    <div className="lead-detail-tabs">
      <div className="detail-form-sec">
        <div className="menu-tab-left-panel">
          <h3>Add Survey Request Details</h3>

          <div className="dealer-tab-left-panel nav">
            <ul>
              <li>
                <NavLink
                  className={`${activeStep === 1 ? 'active completed' : ''}`}
                  onClick={() => {setActiveStep(1); setSelectedSurveys([]);setSurveyDetails([]);}}
                  aria-current="page"
                  style={{"color": `${activeStep === 1 ? '#000' : 'rgba(0, 0, 0, 0.5)'}`}}
                  exact
                >
                  <span className={`${activeStep === 1 ? 'img-type' : 'img-type img-type-inactive'}`}>1</span>
                  {customerDetailCond ? <b>Add Customer Details</b> : 'Add Customer Details'}
                </NavLink>
              </li>

              <li>
                <NavLink
                  className={`${activeStep === 2 ? 'active' : ''}`}
                  onClick={() => customerDetailCond ? setActiveStep(2) : {}}
                  aria-current="page"
                  style={{"color": `${activeStep === 2 ? '#000' : 'rgba(0, 0, 0, 0.5)'}`}}
                  exact
                >
                  <span className={`${activeStep === 2 ? 'img-type' : 'img-type img-type-inactive'}`}>2</span>
                  {customerDetailCond && selectedSurveys?.length ? <b>Select Survey</b> : 'Select Survey'}
                </NavLink>
              </li>

              <li>
                <NavLink
                    className={`${activeStep === 3 ? 'active' : ''}`}
                    onClick={() => customerDetailCond && selectedSurveys?.length ? setActiveStep(3) : {}}
                    aria-current="page"
                    style={{"color": `${activeStep === 3 ? '#000' : 'rgba(0, 0, 0, 0.5)'}`}}
                    exact
                    >
                    <span className={`${activeStep === 3 ? 'img-type' : 'img-type img-type-inactive'}`}>3</span>
                    {customerDetailCond && selectedSurveys?.length && isValidSurveyDetails ? <b>Survey Details</b> : 'Survey Details'}
                </NavLink>
              </li>
            </ul>
          </div>
        </div>

        <div className="route-files">
          {activeStep === 1 && <AddCustomerDetail customerDetails={customerDetails} setCustomerDetails={setCustomerDetails} setActiveStep={setActiveStep} loginData={loginData}/>}
          {activeStep === 2 && <SurveyType customerDetails={customerDetails} selectedSurveys={selectedSurveys} setSelectedSurveys={setSelectedSurveys} setActiveStep={setActiveStep} setSurveyDetails={setSurveyDetails}/>}
          {activeStep === 3 && <AddSurveyDetails selectedSurveys={selectedSurveys} surveyDetails={surveyDetails} setSurveyDetails={setSurveyDetails} loading={loading} uploadSurveyDoc={uploadSurveyDoc} uploadedFileNames={uploadedFileNames} SaveCustomerDetails={SaveCustomerDetails} provinceList={props.provinceList} cityList={props.cityList}/>}
        </div>
      </div>
    </div>
  );
};

export default LeadDetailTabs;
